"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.uniqueId = uniqueId;
require("core-js/modules/es.array.concat.js");
var count = 0;
var countByPrefix = {};
function uniqueId(prefix) {
  if (prefix) {
    var prefixCount = countByPrefix[prefix] || 0;
    prefixCount++;
    countByPrefix[prefix] = prefixCount;
    return "lmig-".concat(prefix).concat(prefixCount);
  }
  count++;
  return "".concat(count);
}
var _default = exports["default"] = uniqueId;